
    import {Component, Vue} from 'vue-property-decorator'
    import BackNav from "@/components/BackNav/index.vue";

    @Component({
        components: { BackNav }
    })
    export default class Error500 extends Vue {

    }
